import { memo } from 'react';
import { DataTableSkeleton } from '../../components/DataTable';
import { ORGANIZATION_STATIONS_COLUMNS, ORGANIZATION_STATIONS_TABLE_MIN_WIDTH } from './OrganizationStationsTable';

export const OrganizationStationsTableSkeleton = memo(
  function OrganizationStationsTableSkeleton() {
    return <DataTableSkeleton columns={ORGANIZATION_STATIONS_COLUMNS} rows={5} minWidth={ORGANIZATION_STATIONS_TABLE_MIN_WIDTH} />;
  },
);

export default OrganizationStationsTableSkeleton;
